import * as React from 'react';
import classNames from 'classnames';
import {Popover as ReactAriaPopover, PopoverProps as ReactAriaPopoverProps} from 'react-aria-components';

import styles from './Popover.module.css';

export interface PopoverProps extends ReactAriaPopoverProps {
  className?: string;
}

export function Popover({className, ...props}: PopoverProps) {
  return <ReactAriaPopover className={classNames(styles.popover, className)} {...props} />;
}
